/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './ie.support';

import angular from 'angular';
import ngMaterial from 'angular-material';
import ngMessages from 'angular-messages';
import ngMdIcons from 'angular-material-icons';
import ngCookies from 'angular-cookies';
import angularSocialshare from 'angular-socialshare';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-local';
import 'angular-translate-storage-cookie';
import 'angular-translate-handler-log';
import 'angular-translate-interpolation-intlmessageformat';
import 'md-color-picker';
import ngSanitize from 'angular-sanitize';
import vAccordion from 'v-accordion';
import 'angular-material-expansion-panel';
import ngAnimate from 'angular-animate';
import 'angular-websocket';
import uiRouter from 'angular-ui-router';
import angularJwt from 'angular-jwt';
import 'angular-drag-and-drop-lists';
import mdDataTable from 'angular-material-data-table';
import fixedTableHeader from 'angular-fixed-table-header';
import ngTouch from 'angular-touch';
import 'angular-carousel';
import 'clipboard';
import 'ngclipboard';
import 'react';
import 'react-dom';
import 'material-ui';
import 'react-schema-form';
import react from 'ngreact';
import '@flowjs/ng-flow/dist/ng-flow-standalone.min';
import 'angular-breadcrumb';
import 'angular-ui-ace';
import 'leaflet/dist/leaflet';
import 'angular-leaflet-directive';
import 'flot/lib/jquery.colorhelpers';
import 'flot/src/jquery.flot';
import 'flot/src/plugins/jquery.flot.time';
import 'flot/src/plugins/jquery.flot.selection';
import 'flot/src/plugins/jquery.flot.pie';
import 'flot/src/plugins/jquery.flot.crosshair';
import 'flot/src/plugins/jquery.flot.stack';
import 'flot.curvedlines/curvedLines';
import ace from 'ace-builds/src-min-noconflict/ace';
import "ace-builds/webpack-resolver";
import 'ace-builds/src-min-noconflict/ext-language_tools';

import tektelicUtilsFullscreen from './common/utils.fullscreen';
import tektelicLocales from './locale/locale.constant';
import tektelicTypes from './common/types.constant';
import tektelicUtils from './common/utils.service';
import tektelicToast from './services/toast';
import tektelicMenu from './services/menu.service';
import tektelicImportExport from './import-export';
import tektelicApiKeycloak from './api/keycloak.service';
import tektelicApiLogin from './api/login.service';
import tektelicApiUser from './api/user.service';
import tektelicApiAdmin from './api/admin.service';
import tektelicApiProvider from './api/provider.service';
import tektelicApiGatewayGroup from './api/gateway-group.service';
import tektelicApiMulticastGroup from './api/multicast-group.service';
import tektelicApiGateway from './api/gateway.service';
import tektelicApiGatewayStatistics from './api/gateway-statistics.service';
import tektelicApiGatewayCommand from './api/gateway-command.service';
import tektelicApiCustomer from './api/customer.service';
import tektelicApiApplication from './api/application.service';
import tektelicApiSubCustomer from './api/subcustomer.service';
import tektelicApiDevice from './api/device.service';
import tektelicApiCredentials from './api/credentials.service';
import tektelicApiEntity from './api/entity.service';
import tektelicApiConfiguration from './api/configuration.service';
import tektelicApiFirmware from './api/firmware.service';
import tektelicApiEvent from './api/event.service';
import tektelicApiNetworkSettings from './api/network-settings.service';
import tektelicApiApiLimits from './api/api-limits.service';
import tektelicApiConverter from './api/converter.service';
import tektelicApiIntegration from './api/integration.service';
import tektelicApiProviderSubscription from './api/provider-subscription.service';
import tektelicApiCustomerSubscription from './api/customer-subscription.service';
import tektelicApiWsSubscription from './api/ws-subscription.service';
import tektelicApiDeviceModel from './api/device-model.service';
import tektelicApiGatewayModel from './api/gateway-model.service';
import tektelicApiTime from './api/time.service';
import tektelicApiGatewayLog from './api/gateway-log.service';
import tektelicApiFileTransfer from './api/file-transfer.service';
import tektelicApiAlarmRules from './api/alarm-rules.service';
import tektelicApiActivityLog from './api/activity-log.service';
import tektelicApiStatistics from './api/statistics.service';
import tektelicApiGrafana from './api/grafana.service';

import tektelicComponents from './components';
import tektelicTable from './table';
import tektelicDialog from './dialog';
import tektelicStatusTable from './status-table';
import tektelicConfiguration from './configuration';
import tektelicJsonConfiguration from './json-configuration';
import tektelicFirmware from './firmware';
import tektelicAlarmRules from './alarm-rule';
import tektelicEvent from './event';

import tektelicLogin from './login';
import tektelicHome from './layout';
import tektelicHomeLinks from './home';
import tektelicProfile from './profile';
import tektelicAdmin from './admin';
import tektelicUser from './user';
import tektelicProvider from './provider';
import tektelicGatewayGroup from './gateway-group';
import tektelicGateway from './gateway';
import tektelicCustomer from './customer';
import tektelicApplication from './application';
import tektelicSubCustomer from './subcustomer';
import tektelicMulticastGroup from './multicast-group';
import tektelicDevice from './device';
import tektelicNetworkSettings from './network-settings';
import tektelicApiLimits from './api-limits';
import tektelicDevicePackets from './packets';
import tektelicConverter from './converter';
import tektelicIntegration from './integration';
import tektelicProviderSubscription from './provider/subscription';
import tektelicCustomerSubscription from './customer/subscription';
import tektelicDeviceModel from './device-model';
import tektelicGatewayModel from './gateway-model';
import tektelicAlarms from './alarm';
import tektelicGatewayLogs from './gateway-log';
import tektelicHardwareEntities from './hardware-entities';
import tektelicActivityLog from './activity-log';
import tektelicStatistics from './statistics';

import 'typeface-roboto';
import 'font-awesome/css/font-awesome.min.css';
import 'angular-material/angular-material.min.css';
import 'angular-material-icons/angular-material-icons.css';
import 'angular-gridster/dist/angular-gridster.min.css';
import 'v-accordion/dist/v-accordion.min.css';
import 'angular-material-expansion-panel/dist/md-expansion-panel.min.css';
import 'md-color-picker/dist/mdColorPicker.min.css';
import 'angular-hotkeys/build/hotkeys.min.css';
import 'angular-carousel/dist/angular-carousel.min.css';
import 'angular-material-data-table/dist/md-data-table.min.css';
import 'leaflet/dist/leaflet.css';
import '../scss/main.scss';

import AppConfig from './app.config';
import GlobalInterceptor from './global-interceptor.service';
import AppRun from './app.run';
import {DynamicConfigs} from './dynamic-configs-exports';


window.DynamicConfigs = DynamicConfigs; // eslint-disable-line
console.log(window.DynamicConfigs); // eslint-disable-line

// ace editor configuration: don't create Worker from Blob because of CSP
ace.config.set("loadWorkerFromBlob", false);

angular.module('tektelic', [
    ngMaterial,
    ngMessages,
    ngMdIcons,
    ngCookies,
    angularSocialshare,
    'pascalprecht.translate',
    'mdColorPicker',
    ngSanitize,
    'ncy-angular-breadcrumb',
    vAccordion,
    'material.components.expansionPanels',
    ngAnimate,
    'ngWebSocket',
    angularJwt,
    'dndLists',
    mdDataTable,
    fixedTableHeader,
    ngTouch,
    'angular-carousel',
    'ngclipboard',
    react.name,
    'flow',
    'ui.ace',
    'leaflet-directive',
    uiRouter,
    tektelicUtilsFullscreen,
    tektelicLocales,
    tektelicTypes,
    tektelicUtils,
    tektelicToast,
    tektelicMenu,
    tektelicImportExport,
    tektelicApiKeycloak,
    tektelicApiLogin,
    tektelicApiUser,
    tektelicApiAdmin,
    tektelicApiProvider,
    tektelicApiGatewayGroup,
    tektelicApiMulticastGroup,
    tektelicApiGateway,
    tektelicApiGatewayStatistics,
    tektelicApiGatewayCommand,
    tektelicApiCustomer,
    tektelicApiApplication,
    tektelicApiSubCustomer,
    tektelicApiDevice,
    tektelicApiCredentials,
    tektelicApiEntity,
    tektelicApiConfiguration,
    tektelicApiFirmware,
    tektelicApiEvent,
    tektelicApiNetworkSettings,
    tektelicApiApiLimits,
    tektelicApiConverter,
    tektelicApiStatistics,
    tektelicApiGrafana,
    tektelicApiIntegration,
    tektelicApiProviderSubscription,
    tektelicApiCustomerSubscription,
    tektelicApiWsSubscription,
    tektelicApiDeviceModel,
    tektelicApiGatewayModel,
    tektelicApiTime,
    tektelicApiGatewayLog,
    tektelicApiFileTransfer,
    tektelicApiActivityLog,
    tektelicComponents,
    tektelicTable,
    tektelicDialog,
    tektelicConfiguration,
    tektelicStatusTable,
    tektelicJsonConfiguration,
    tektelicFirmware,
    tektelicAlarmRules,
    tektelicEvent,
    tektelicStatistics,
    tektelicLogin,
    tektelicHome,
    tektelicHomeLinks,
    tektelicProfile,
    tektelicAdmin,
    tektelicUser,
    tektelicProvider,
    tektelicProviderSubscription,
    tektelicGatewayGroup,
    tektelicGateway,
    tektelicCustomer,
    tektelicCustomerSubscription,
    tektelicApplication,
    tektelicSubCustomer,
    tektelicMulticastGroup,
    tektelicDevice,
    tektelicNetworkSettings,
    tektelicApiLimits,
    tektelicDevicePackets,
    tektelicConverter,
    tektelicIntegration,
    tektelicDeviceModel,
    tektelicGatewayModel,
    tektelicAlarms,
    tektelicGatewayLogs,
    tektelicHardwareEntities,
    tektelicApiAlarmRules,
    tektelicActivityLog])
    .config(AppConfig)
    .factory('globalInterceptor', GlobalInterceptor)
    .run(AppRun);



// WEBPACK FOOTER //
// ./src/app/app.js